// extracted by mini-css-extract-plugin
module.exports = {"endpoint":"qRcCm"};